<template>
  <mdb-container class="gp-has-header">
    <div v-if="cartInfo && cartInfo.totalItems == 0">You have no shopping carts right now.</div>
    <div v-if="cartInfo && cartInfo.totalCarts>0 && !currentCart" class="text-center">
      <h2>You Have Multiple Carts at the Moment</h2>
      <h4>Select Store</h4>
      <div v-for="cart in cartInfo.carts" :key="cart.id">
        <mdb-btn @click="loadCart(cart)">{{ cart.storeName }}</mdb-btn>
      </div>
    </div>
    <div v-if="currentCart" class="mb-4">
      <h5>{{ currentCart.name }} Cart</h5>
      <mdb-stepper v-if="cartStep>0 && currentCart" id="new-group-stepper"
                   v-model="cartStep" :options="options"
                   :steps="settingsStepper"
                   :validatedSteps="validatedSteps"
                   @submit="completePurchase"
                   buttons
                   validation
                   @changeStep="stepChanged">
        <template #1>
          <cart-items :allowEdit="true"
                      :currentCart="currentCart"
                      @editQty="editQty" @removeItem="removeItem"/>
        </template>
        <template #2>
          <div class="text-left">
            <h2 v-if="addresses.length>0" class="text-left">Address{{ addresses.length > 1 ? 'es' : '' }}</h2>
            <gp-address v-if="editingAddress"
                        :address="editingAddress"
                        :allow-cancel="addresses.length>0"
                        :country="userDetails.country"
                        :states="states"
                        may-edit
                        @cancel="editingAddress = null"
                        @complete="saveAddress"/>

            <mdb-list-group v-if="!editingAddress">
              <mdb-list-group-item v-for="address in addresses" :key="address.id">
                <mdb-badge v-if="currentCart.address && address.id == currentCart.address"
                           color="success"
                           style="position:absolute; left:0; top:0; ">Selected
                </mdb-badge>
                <gp-address :address="address" :country="userDetails.country"
                            class="mt-2"/>
                <mdb-btn v-if="!currentCart.address || (currentCart.address && address.id != currentCart.address)"
                         icon="check"
                         rounded size="sm" @click="selectAddress(address)">Select
                </mdb-btn>
                <mdb-btn icon="pencil" rounded size="sm" @click="editAddress(address)">Edit</mdb-btn>
              </mdb-list-group-item>
            </mdb-list-group>
            <mdb-btn v-if="addresses.length>0 && !editingAddress" icon="plus-circle" rounded
                     size="sm"
                     @click="newAddress">Add Address
            </mdb-btn>
          </div>
        </template>

        <template #3>
          <div class="text-left">
            <mdb-card>
              <mdb-card-header><h4>Credit Card</h4></mdb-card-header>
              <mdb-card-body>
                <div v-if="!creditCard || !creditCard.ccLast4 || changeCard">
                  <card :class='{ complete }'
                        :stripe='cartInfo.checkoutKey'
                        class='stripe-card'
                        @change='complete = $event.complete'
                  />
                  <mdb-input v-model="ccName" label="Name" placeholder="Name as it appears on Card" type="text"/>
                  <mdb-btn :disabled="!complete || !ccName " color="success" icon="check-circle" rounded size="sm"
                           @click="processCard">Submit Card
                  </mdb-btn>
                  <mdb-btn v-if="creditCard && creditCard.ccLast4" color="warning" icon="minus-circle" rounded size="sm"
                           @click="changeCard=false">Cancel
                  </mdb-btn>
                </div>
                <div v-if="creditCard && creditCard.ccLast4 && !changeCard">
                  <div>Credit card on file: {{ creditCard.type }} **** **** **** {{ creditCard.ccLast4 }}</div>
                  <div>Expires {{ creditCard.ccExpire }}</div>
                  <mdb-btn icon="credit-card" rounded size="sm" @click="changeCard=true">Change Card</mdb-btn>
                </div>
              </mdb-card-body>
            </mdb-card>
          </div>
        </template>
        <template #4>
          <cart-items :allowEdit="false"
                      :currentCart="currentCart"
                      />
        </template>

      </mdb-stepper>
    </div>
    <yes-no-modal v-if="showDeleteModal" @no="showDeleteModal=false" @yes="doDeleteItem"/>

    <mdb-modal :show="showEditModal" @close="showEditModal = false">
      <mdb-modal-header :close="true" center class="secondary-color text-white">Edit Quantity</mdb-modal-header>
      <mdb-modal-body>
        <mdb-input v-model="newQuantity" :min="1" :step="1" label="New Quantity" type="number"/>
        <mdb-btn icon="save" rounded size="sm" @click="submitNewQuantity">Save</mdb-btn>
        <mdb-btn color="warning" icon="minus-circle" rounded size="sm" @click="showEditModal=false">Cancel</mdb-btn>
      </mdb-modal-body>
    </mdb-modal>

  </mdb-container>
</template>

<script>
import api from '../../services/groupsPlaceApi.js'
import yesNoModal from "../common/YesNoModal";
import CartItems from "./CartItems";
import gpAddress from "../common/Address";
import {Card, createToken} from 'vue-stripe-elements-plus'

import {
  mdbBadge,
  mdbBreadcrumb,
  mdbBreadcrumbItem,
  mdbBtn,
  mdbCard,
  mdbCardBody,
  mdbCardHeader,
  mdbCardImage,
  mdbCol,
  mdbContainer,
  mdbIcon,
  mdbInput,
  mdbLightbox,
  mdbListGroup,
  mdbListGroupItem,
  mdbMask,
  mdbModal,
  mdbModalBody,
  mdbModalHeader,
  mdbRow,
  mdbStepper,
  mdbTbl,
  mdbTblBody,
  mdbTblHead,
  mdbTooltip,
  mdbView
} from "mdbvue";

export default {
  name: 'shopping-cart',
  components: {
    mdbBadge,
    mdbContainer,
    mdbBtn,
    mdbIcon,
    yesNoModal,
    mdbCard,
    mdbCardHeader,
    mdbView,
    mdbCardImage,
    mdbRow,
    mdbCol,
    mdbCardBody,
    mdbInput,
    mdbMask,
    mdbBreadcrumb,
    mdbBreadcrumbItem,
    mdbTbl,
    mdbTblHead,
    mdbTblBody,
    mdbLightbox,
    mdbListGroup,
    mdbListGroupItem,
    mdbModal,
    mdbModalHeader,
    mdbModalBody,
    mdbStepper,
    mdbTooltip,
    CartItems,
    gpAddress,
    Card
  },
  computed: {
    userDetails: function () {
      return this.$store.state.userDetails
    },
    executing: function () {
      return this.$store.state.executing
    }
  },
  filters: {
    formatNumber: function (val) {
      if (!val) return "0.00"
      return val.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})
    }
  },
  data() {
    return {
      cartInfo: null,
      creditCard: null,
      currentCart: null,
      deleteCandidate: null,
      showDeleteModal: false,
      complete: false,
      checkoutKey: null,
      cartStep: 0,
      ccName: null,
      editingItem: null,
      newQuantity: null,
      changeCard: false,
      showEditModal: false,
      validatedSteps: {},
      fetchedShipping: false,
      fetchedCard: false,
      editingAddress: null,
      addresses: [],
      states: [],
      addressSelected: null,
      settingsStepper: [
        {icon: "shopping-cart", far: true, name: "Review Cart"},
        {icon: "truck", far: true, name: "Shipping Information"},
        {icon: "credit-card", name: "Payment"},
        {icon: "check", name: "Finish"}
      ],
      options: {
        stepBtn: {color: "info", active: "amber", iconClass: "white-text"},
        nextBtn: {outline: "info", icon: "chevron-right"},
        prevBtn: {outline: "info", icon: "chevron-left"},
        submitBtn: {color: "amber", icon: "check", text: "Complete Purchase"},
        lineColor: "amber"
      },
    }
  },
  beforeRouteLeave(to, from, next) {

    if (this.currentCart && this.currentCart.items.length == 0) {
      next()
      return
    }

    if (this.currentCart && this.cartStep == 4) {
      next()
      return
    }

    if (this.currentCart && this.cartStep == 1 && this.cartInfo.carts.length > 1) {
      next(false)
      this.currentCart = null
      this.cartStep = 0
      return
    }

    if (this.currentCart && this.cartStep > 1) {
      next(false)
      this.cartStep--
      return
    }

    next()
  },
  mounted() {
    document.title = "Shopping Cart"
    this.$store.dispatch("setExecuting", true)
    api.get("/shopping/cartInfo").then(
      (results) => {
        this.cartInfo = results.data
        if (this.cartInfo.carts.length == 1) {
          this.cartStep = 1
          this.validatedSteps[1] = true
          this.loadCart(this.cartInfo.carts[0])
        }
      },
      (error) => {
        this.$notify.error({message: error.response.data, timeOut: 20000})
      }).then(() => {
                this.$store.dispatch("setExecuting", false)
              }
    )
  }
  ,
  methods: {
    completePurchase() {
      this.$store.dispatch("setExecuting", true);
      api.post("/shopping/completePurchase/" + this.currentCart.id, {}).then(
        (results) => {
          this.$notify.success({message: "Thank you. Your order is now complete.", timeOut: 5000})
          this.$router.push("/shop")
        },
        (error) => {
          this.$notify.error({message: "Purchase failed. " + error.response.data, timeOut: 20000})
        }).then(() => {
        this.$store.dispatch("setExecuting", false)
      })
    },
    processCard() {
      createToken({name: this.ccName, currency: "usd"}).then(data =>
                                                               this.submitPayment(data.token)
      )
    },
    submitPayment(token) {
      this.$store.dispatch("setExecuting", true);
      let payload = {token: token.id, name: this.ccName}
      api.post("/user/paymentData/", payload).then(
        (results) => {
          this.changeCard = false
          this.validatedSteps[3] = true
          this.cartInfo.creditCard = results.data
          this.cartStep++
        },
        (error) => {
          this.$notify.error({message: "Could not save card. " + error.response.data, timeOut: 20000})
        }).then(() => {
        this.$store.dispatch("setExecuting", false)
      })
    },
    editAddress(address) {
      this.editingAddress = JSON.parse(JSON.stringify(address))
    },
    selectAddress(address) {
      this.$store.dispatch("setExecuting", true)
      api.post("/shopping/address/" + this.currentCart.id, address).then(
        (results) => {
          this.currentCart.address = address.id
          this.validatedSteps[2] = true
          this.cartStep++
        },
        (error) => {
          this.$notify.error({message: error.response.data, timeOut: 20000})
        }).then(() => {
        this.$store.dispatch("setExecuting", false)
      })
    },
    stepChanged(step) {
      if (step == 2 && !this.fetchedShipping) this.fetchShipping()
      if (step == 3 && !this.fetchedCard) this.fetchCard()
    },
    fetchShipping() {
      this.$store.dispatch("setExecuting", true)
      api.get("/shopping/shippingAddresses/" + this.currentCart.storeId).then(
        (results) => {
          this.addresses = results.data.addresses
          this.states = results.data.states
          this.fetchedShipping = true
          if (this.addresses.length == 0) {
            this.newAddress()
          }
        },
        (error) => {
          this.$notify.error({message: error.response.data, timeOut: 20000})
        }).then(() => {
                  this.$store.dispatch("setExecuting", false)
                }
      )
    },
    fetchCard() {
      this.$store.dispatch("setExecuting", true)
      api.get("/user/creditCard/").then(
        (results) => {
          this.creditCard = results.data
          if (this.creditCard.ccLast4) this.validatedSteps[3] = true
        },
        (error) => {
          this.$notify.error({message: error.response.data, timeOut: 20000})
        }).then(() => {
                  this.$store.dispatch("setExecuting", false)
                }
      )
    },
    newAddress() {
      this.editingAddress = {
        id: null,
        line1: "",
        line2: "",
        line3: "",
        line4: "",
        city: "",
        state: null,
        postal: ""
      }
    },
    editQty(item) {
      this.editingItem = item
      this.newQuantity = item.quantity
      this.showEditModal = true
    },
    submitNewQuantity() {
      this.showEditModal = false
      this.$store.dispatch("setExecuting", true)
      api.post("/shopping/changeQuantity/" + this.editingItem.id, {quantity: this.newQuantity}).then(
        (results) => {
          this.currentCart = results.data
          this.newQuanity = null
          this.editingItem = null
        },
        (error) => {
          this.$notify.error({message: error.response.data, timeOut: 20000})
        }).then(() => {
        this.$store.dispatch("setExecuting", false)
      })
    },
    saveAddress() {
      this.$store.dispatch("setExecuting", true)
      api.post("/user/address", this.editingAddress).then(
        (results) => {
          if (this.editingAddress.id) {
            let loc = this.addresses.indexOf(this.editingAddress)
            this.addresses.splice(loc, 1)
          }
          this.addresses.unshift(results.data)
          this.editingAddress = null
        },
        (error) => {
          this.$notify.error({message: error.response.data, timeOut: 20000})
        }).then(() => {
        this.$store.dispatch("setExecuting", false)
      })
    },
    removeItem(item) {
      this.deleteCandidate = item
      this.showDeleteModal = true
    },
    doDeleteItem() {
      this.showDeleteModal = false
      this.$store.dispatch("setExecuting", true)
      api.delete("/shopping/deleteItem/" + this.deleteCandidate.id).then(
        (results) => {
          this.currentCart = results.data
          if (this.currentCart.items.length == 0) {
            this.$router.push("/shop")
            return
          }
        },
        (error) => {
          this.$notify.error({message: error.response.data, timeOut: 20000})
        }).then(() => {
        this.$store.dispatch("setExecuting", false)
      })
    },
    startOver() {
      this.currentProduct = null;
      this.currentStore = null;
    },
    loadCart(cart) {
      this.cartStep = 1
      this.validatedSteps = {}
      this.validatedSteps[1] = true
      this.currentProduct = null
      this.$store.dispatch("setExecuting", true)
      api.get("/shopping/cart/" + cart.id).then(
        (results) => {
          this.currentCart = results.data
          if (this.currentCart.address) this.validatedSteps[2] = true
        },
        (error) => {
          this.$notify.error({message: error.response.data, timeOut: 20000})
        }).then(() => {
        this.$store.dispatch("setExecuting", false)
      })
    }
  }

}
;
</script>

<style scoped>
.breadcrumb-with-arrows .breadcrumb-item + .breadcrumb-item::before {
  font-family: "Font Awesome 5 Pro";
  font-weight: 900;
  content: "\f0da";
}

</style>

<style lang='scss'>
.stripe-card {
  width: 300px;
  border: 1px solid grey;
}

.stripe-card.complete {
  border-color: green;
}
</style>

